import React, { useCallback, useMemo } from "react"
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons/faCircleQuestion"
import { faMessage } from "@fortawesome/free-regular-svg-icons/faMessage"
import { faLightbulb } from "@fortawesome/free-regular-svg-icons/faLightbulb"
import { faBook } from "@fortawesome/free-solid-svg-icons/faBook"
import { Menu, type MenuItemType } from "@mallardbay/lib-react-components"

import {
    FEATURE_REQUEST_URL,
    PROFILE_MENU_LABELS,
    TEST_IDS,
} from "~config/constants"
import {
    getKnowledgeLink,
    openInNewTab,
} from "~utils/helpers/navigation-helpers"
import HubspotChat from "~components/shared/profile-menu/hubspot-chat"
import { useMaybeOutfitterAssistant } from "~contexts/outfitter-assistant-provider"
import COPY from "~config/copy-constants"

export default function HelpMenuButton() {
    const assistant = useMaybeOutfitterAssistant()
    const handleAskQuestion = useCallback(() => {
        assistant?.openWithPrompt(COPY.OUTFITTER_ASSISTANT_SUPPORT_PROMPT)
    }, [assistant])
    const menuItems = useMemo(
        () =>
            getHelpMenuItems({
                onAskQuestion: handleAskQuestion,
            }),
        [handleAskQuestion]
    )

    return (
        <>
            <Menu
                menuItems={menuItems}
                menuButtonIcon={faCircleQuestion}
                menuTestId={TEST_IDS.HELP_MENU_BUTTON}
                placement="bottom-end"
            />
            <HubspotChat />
        </>
    )
}

function getHelpMenuItems({
    onAskQuestion,
}: {
    readonly onAskQuestion: () => void
}): MenuItemType[] {
    return [
        {
            label: PROFILE_MENU_LABELS.ASK_A_QUESTION,
            icon: faMessage,
            onClick: onAskQuestion,
            hasDivider: true,
        },
        {
            label: PROFILE_MENU_LABELS.REQUEST_FEATURE,
            icon: faLightbulb,
            onClick: () => {
                openInNewTab(FEATURE_REQUEST_URL)
            },
        },
        {
            label: PROFILE_MENU_LABELS.KNOWLEDGE_BASE,
            icon: faBook,
            onClick: () => {
                openInNewTab(getKnowledgeLink())
            },
        },
    ]
}
